import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const partDiscountsThirtyMothersState = atom({
  key: "partDiscountsThirtyMothersState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
